import { BookingFormGuestsStorage } from './lib/booking_form_guests_storage';
import { ClientFormStorage } from './lib/client_form_storage';

export function clearClientFormData() {
  ClientFormStorage.clear();
  BookingFormGuestsStorage.clear();
}
